//Include Both Helper File with needed methods
import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "axios";

// state
export const fetchStateDetails = createAsyncThunk(
  "fetchStateDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/state/${id}/list `);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch details" }
      );
    }
  }
);
// city
export const fetchCityDetails = createAsyncThunk(
  "fetchCityDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/city/${id}/list `);

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch details" }
      );
    }
  }
);
